import React, { useState, useEffect } from "react";
import ProductCard from "../components/ProductCard";
import CategoryScroll from "../components/CategoryScroll";
import Header from "../components/Header";
import Footer from "../components/Footer";
export default function CategoryPage() {
    const [selectedCategory, setSelectedCategory] = useState("All Categories");
    const [showFilter, setShowFilter] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const categories = [
        { name: "All Categories", image: "https://picsum.photos/80/80?1" },
        { name: "T-Shirts", image: "https://picsum.photos/80/80?2" },
        { name: "Jackets", image: "https://picsum.photos/80/80?3" },
        { name: "Shoes", image: "https://picsum.photos/80/80?4" },
        { name: "Accessories", image: "https://picsum.photos/80/80?5" },
        { name: "Watches", image: "https://picsum.photos/80/80?6" },
        { name: "Bags", image: "https://picsum.photos/80/80?7" },
    ];
    const products = [
        { name: "Men T-Shirt", price: 499, category: "T-Shirts" },
        { name: "Women Dress", price: 899, category: "T-Shirts" },
        { name: "Sports Shoes", price: 1299, category: "Shoes" },
        { name: "Jacket", price: 1599, category: "Jackets" },
        { name: "Casual Shirt", price: 699, category: "T-Shirts" },
        { name: "Leather Belt", price: 299, category: "Accessories" },
        { name: "Sneakers", price: 1199, category: "Shoes" },
        { name: "Watch", price: 2499, category: "Watches" },
    ];
    const filteredProducts = products.filter(
        (p) => selectedCategory === "All Categories" || p.category === selectedCategory
    );
    return (
        <div>
            <Header />
            <div className="category-page">
                <CategoryScroll
                    categories={categories}
                    selectedCategory={selectedCategory}
                    onSelectCategory={setSelectedCategory} />
                {isMobile && selectedCategory !== "All Categories" && (
                    <button className="filter-toggle-btn" onClick={() => setShowFilter(true)}>Show Filters</button>
                )}
                <div className="category-content">
                    {isMobile && selectedCategory !== "All Categories" && (
                        <>
                            <aside className={`category-filter ${showFilter ? "active" : ""}`}>
                                <button className="filter-close-btn" onClick={() => setShowFilter(false)}>×</button>
                                <h3>Filters</h3>
                                <div className="filter-group">
                                    <h4>Category</h4>
                                    {categories.slice(1).map((c, i) => (
                                        <label key={i}>
                                            <input type="checkbox" /> {c.name}
                                        </label>
                                    ))}
                                </div>
                                <div className="filter-group">
                                    <h4>Price</h4>
                                    <label>
                                        <input type="radio" name="price" /> Under ₹500
                                    </label>
                                    <label>
                                        <input type="radio" name="price" /> ₹500 - ₹1000
                                    </label>
                                    <label>
                                        <input type="radio" name="price" /> Above ₹1000
                                    </label>
                                </div>
                            </aside>
                            {showFilter && (
                                <div
                                    className="filter-overlay"
                                    onClick={() => setShowFilter(false)}
                                ></div>
                            )}
                        </>
                    )}
                    <div className="category-products">
                        <div className="products-container">
                            {filteredProducts.map((p, i) => (
                                <ProductCard key={i} {...p} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}